export default "__VITE_ASSET__DkCiu0ah__"